import type { Meta, StoryObj } from "@storybook/react";

import type { ViewAllCardProps } from "@/ui/composed/cards/ViewAllCard";
import ViewAllCard from "@/ui/composed/cards/ViewAllCard";

const StoryMeta: Meta<ViewAllCardProps> = {
  title: "Components/Common/View All Card",
  component: ViewAllCard,
  argTypes: {
    onPress: { action: "pressed" },
    testID: { control: "text" },
  },
  args: {
    testID: "storybook",
  },
};

type Story = StoryObj<ViewAllCardProps>;

export const Primary: Story = {};

export default StoryMeta;
